// /* eslint-disable camelcase */
// import React from 'react';
// import { Field, Form } from 'formik';
// import { Button, Col, Row } from 'reactstrap';
// import LoadingButton from 'components/common/LoadingButton';
// import FormikInputField from 'components/Fields/FormikInputField';
// import CardWithTitle from 'components/CardWithTitle';
// import EditUploadWrapper from 'components/EditUploadWrapper';
// import S3FileUploadField from 'components/S3FileUploadField';

// const WhatsNewForm = (props) => {
//   const {
//     handleSubmit,
//     isSubmitting,
//     isValid,
//     dirty,
//     toggleWhatsNew,
//     values,
//     setFieldValue,
//   } = props;

//   const [loading, setLoading] = React.useState(false);

//   const handleCancel = (val) => {
//     setFieldValue(val, '');
//   };

//   return (
//     <Form onSubmit={handleSubmit}>
//       <CardWithTitle>
//         <Row>
//           <Col sm={12}>
//             <Field
//               label="Title"
//               name="title"
//               type="text"
//               component={FormikInputField}
//               required
//             />
//           </Col>

//           <Col sm={12} className="mt-3">
//             <Field
//               label="Description"
//               name="description"
//               type="textarea"
//               className="msg-field"
//               component={FormikInputField}
//               required
//             />
//           </Col>

//           <Col sm={12} className="mt-3">
//             {values?.imageUrl ? (
//               <EditUploadWrapper
//                 label="Image (Optional)"
//                 name="imageUrl"
//                 fileName={values.imageUrl}
//                 handleCancel={() => handleCancel('imageUrl')}
//                 required={false}
//               />
//             ) : (
//               <S3FileUploadField
//                 label="Image (Optional)"
//                 name="imageUrl"
//                 pathUrl="polystox_images/whatsnew_image"
//                 accept=".png, .jpg, .jpeg, .gif"
//                 setLoading={setLoading}
//                 required={false}
//                 containerName="public-assets"
//               />
//             )}
//           </Col>
//         </Row>
//       </CardWithTitle>

//       <div className="form-btn d-flex justify-content-end mt-4">
//         <Button
//           color="secondary"
//           outline
//           size="sm"
//           type="button"
//           className="me-2 mw-100"
//           onClick={toggleWhatsNew}
//         >
//           Cancel
//         </Button>
//         <LoadingButton
//           className="mw-100 loading-button"
//           loading={isSubmitting}
//           disabled={!isValid || !dirty || isSubmitting || loading}
//           color="warning"
//           size="sm"
//           type="submit"
//         >
//           {loading ? 'Uploading...' : 'Send'}
//         </LoadingButton>
//       </div>
//     </Form>
//   );
// };

// export default WhatsNewForm;

/* eslint-disable camelcase */
import React from 'react';
import { Field, Form } from 'formik';
import { Button, Col, Row } from 'reactstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import LoadingButton from 'components/common/LoadingButton';
import FormikInputField from 'components/Fields/FormikInputField';
import CardWithTitle from 'components/CardWithTitle';
import EditUploadWrapper from 'components/EditUploadWrapper';
import S3FileUploadField from 'components/S3FileUploadField';

const WhatsNewForm = (props) => {
  const {
    handleSubmit,
    isSubmitting,
    isValid,
    dirty,
    toggleWhatsNew,
    values,
    setFieldValue,
    errors,
    touched,
  } = props;

  const [loading, setLoading] = React.useState(false);

  const handleCancel = (field) => {
    setFieldValue(field, '');
  };

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle>
        <Row>
          {/* TITLE */}
          <Col sm={12}>
            <Field
              label="Title"
              name="title"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>

          {/* DESCRIPTION */}
          <Col sm={12} className="mt-3">
            <label className="form-label">
              Description <span className="text-danger">*</span>
            </label>

            <ReactQuill
              theme="snow"
              value={values.description}
              onChange={(value) => setFieldValue('description', value)}
              modules={WhatsNewForm.modules}
              formats={WhatsNewForm.formats}
              bounds=".app"
              placeholder="Type description here..."
            />

            {errors.description && touched.description && (
              <div className="text-danger mt-1">{errors.description}</div>
            )}
          </Col>

          {/* IMAGE */}
          <Col sm={12} className="mt-3">
            {values?.imageUrl ? (
              <EditUploadWrapper
                label="Image (Optional)"
                name="imageUrl"
                fileName={values.imageUrl}
                handleCancel={() => handleCancel('imageUrl')}
                required={false}
              />
            ) : (
              <S3FileUploadField
                label="Image (Optional)"
                name="imageUrl"
                pathUrl="polystox_images/whatsnew_image"
                accept=".png, .jpg, .jpeg, .gif"
                setLoading={setLoading}
                required={false}
                containerName="public-assets"
              />
            )}
          </Col>
        </Row>
      </CardWithTitle>

      {/* BUTTONS */}
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={toggleWhatsNew}
        >
          Cancel
        </Button>

        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting || loading}
          color="warning"
          size="sm"
          type="submit"
        >
          {loading ? 'Uploading...' : 'Send'}
        </LoadingButton>
      </div>

      {/* ✅ FIXED HEIGHT CSS */}
      <style>
        {`
          .ql-container {
            min-height: 200px;
          }

          .ql-editor {
            min-height: 160px;
            padding-bottom: 20px;
          }
        `}
      </style>
    </Form>
  );
};

/* QUILL CONFIG */
WhatsNewForm.modules = {
  toolbar: {
    container: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['link'],
      ['clean'],
    ],
  },
};

WhatsNewForm.formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'align',
  'link',
];

export default WhatsNewForm;
